import { render, staticRenderFns } from "./WflowDetail.vue?vue&type=template&id=4b5a714c&scoped=true"
import script from "./WflowDetail.vue?vue&type=script&lang=js"
export * from "./WflowDetail.vue?vue&type=script&lang=js"
import style0 from "./WflowDetail.vue?vue&type=style&index=0&id=4b5a714c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b5a714c",
  null
  
)

export default component.exports